export enum CustomerType {
    Company = 'Company',
    Person = 'Person',
    Both = 'Both'
}